import { render, staticRenderFns } from "./pay_list.vue?vue&type=template&id=70bb1a1e"
import script from "./pay_list.vue?vue&type=script&lang=js"
export * from "./pay_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports